import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Group, Text, Tooltip, factory, useProps } from "@components/mantine";
import { SourceVisibility } from "@core/api";
import { Translation } from "@core/locales";
import { AccessPrivateSize16Px, AccessPrivateSize24Px, AccessPrivateSize32Px, UnlockSize16Px, UnlockSize24Px, UnlockSize32Px, UserSize16Px, UserSize24Px, UserSize32Px } from "@coveord/plasma-react-icons";
import { Locales } from "../../../strings/Locales.js";
import { useSourceIdentityContext } from "../SourceIdentityContext.js";
var _obj, _obj1, _obj2;
var SOURCE_VISIBILITY_IMAGE_MAPPINGS = {
    sm: (_obj = {}, _define_property(_obj, SourceVisibility.PRIVATE, UserSize16Px), _define_property(_obj, SourceVisibility.SECURED, AccessPrivateSize16Px), _define_property(_obj, SourceVisibility.SHARED, UnlockSize16Px), _obj),
    md: (_obj1 = {}, _define_property(_obj1, SourceVisibility.PRIVATE, UserSize24Px), _define_property(_obj1, SourceVisibility.SECURED, AccessPrivateSize24Px), _define_property(_obj1, SourceVisibility.SHARED, UnlockSize24Px), _obj1),
    lg: (_obj2 = {}, _define_property(_obj2, SourceVisibility.PRIVATE, UserSize32Px), _define_property(_obj2, SourceVisibility.SECURED, AccessPrivateSize32Px), _define_property(_obj2, SourceVisibility.SHARED, UnlockSize32Px), _obj2)
};
var defaultProps = {
    disabled: false,
    showTooltip: false,
    size: "md"
};
export var SourceIdentityVisibilityIcon = factory(function(props, ref) {
    var _ref = useProps("SourceIdentityVisibilityIcon", defaultProps, props), children = _ref.children, disabled = _ref.disabled, showTooltip = _ref.showTooltip, size = _ref.size, others = _object_without_properties(_ref, [
        "children",
        "disabled",
        "showTooltip",
        "size"
    ]);
    var _$ref = useSourceIdentityContext(), getStyles = _$ref.getStyles, sourceVisibility = _$ref.sourceVisibility;
    if (!sourceVisibility) {
        return null;
    }
    var IconComponent = SOURCE_VISIBILITY_IMAGE_MAPPINGS[size][sourceVisibility];
    var renderedIconComponent = /*#__PURE__*/ _jsx(IconComponent, {
        "data-disabled": disabled
    });
    var renderedIconComponentWithChildren = /*#__PURE__*/ _jsxs(Group, {
        align: "self-start",
        gap: "xs",
        children: [
            children,
            renderedIconComponent
        ]
    });
    return /*#__PURE__*/ _jsx(Tooltip, {
        label: /*#__PURE__*/ _jsxs(Translation, {
            t: Locales,
            i18nKey: "SourceIdentity.VisibilityIcon.".concat(sourceVisibility, ".tooltip"),
            children: [
                /*#__PURE__*/ _jsx("div", {}),
                /*#__PURE__*/ _jsx(Text, {
                    inherit: true,
                    fw: 500
                })
            ]
        }),
        disabled: !showTooltip,
        children: /*#__PURE__*/ _jsx(Box, _object_spread_props(_object_spread({
            ref: ref,
            "data-size": size
        }, getStyles("visibilityIcon"), others), {
            children: children ? renderedIconComponentWithChildren : renderedIconComponent
        }))
    });
});
SourceIdentityVisibilityIcon.displayName = "@resourceIdentity/source/SourceIdentity/VisibilityIcon";

//# sourceMappingURL=SourceIdentityVisibilityIcon.js.map